export default __webpack_public_path__ + "static/media/chat-icon.0bff0a85.svg";